import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'invoiceType'
})
export class InvoiceTypePipe implements PipeTransform {

    transform(type: string, ...args: unknown[]): unknown {

        switch (type) {
            case 'franchise':
                return 'Franchisegebühren';
            case 'recurring':
                return 'Dauerrechnungen';
            case 'entry':
                return 'Einstiegsgebühren';
            case 'various':
                return 'Diverses';
            case 'credit':
                return 'Gutschrift';
            default:
                return type;
        }
    }

}
